var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgNewRelease = function SvgNewRelease(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    fill: "currentColor",
    stroke: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.167 13.333l4.666-4.667M6.5 13.333L8.833 11m-5.666-1L5.5 7.666m5.333-4l-2-1L9.167 5 7.833 6.333l2 .333 1 2 1-2 2-.333L12.5 5l.333-2.334-2 1z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgNewRelease;